(function () {
  if (window.__standReminderInit) return;
  window.__standReminderInit = true;

  function getCheckoutButton(clickedElement) {
    if (clickedElement) {
      return clickedElement.closest('#checkout[name="checkout"], button[name="checkout"]');
    }

    return document.querySelector('#checkout[name="checkout"], button[name="checkout"]');
  }

  function getReminderCards() {
    return document.querySelectorAll('[data-stand-reminder-card]');
  }

  function isReminderRequired() {
    var checkoutButton = getCheckoutButton();

    if (checkoutButton && checkoutButton.getAttribute('data-stand-reminder-required') === 'true') {
      return true;
    }

    var card = document.querySelector('[data-stand-reminder-card]');
    return card && card.getAttribute('data-stand-reminder-required') === 'true';
  }

  function wasDismissed() {
    return sessionStorage.getItem('standReminderDismissed') === 'true';
  }

  function hideCardWithAnimation(card) {
    if (!card || card.hidden) return;

    card.classList.add('is-closing');
    card.setAttribute('aria-hidden', 'true');

    window.setTimeout(function () {
      card.hidden = true;
      card.classList.remove('is-closing');
    }, 240);
  }

  function dismissReminder() {
    sessionStorage.setItem('standReminderDismissed', 'true');

    getReminderCards().forEach(function (card) {
      hideCardWithAnimation(card);
    });

    document.querySelectorAll('#checkout[name="checkout"], button[name="checkout"]').forEach(function (button) {
      button.setAttribute('data-stand-reminder-accepted', 'true');
    });
  }

  function showReminderIfNeeded() {
    var required = isReminderRequired();

    getReminderCards().forEach(function (card) {
      var cardRequired = card.getAttribute('data-stand-reminder-required') === 'true';

      if (required && cardRequired && !wasDismissed()) {
        card.classList.remove('is-closing');
        card.hidden = false;
        card.setAttribute('aria-hidden', 'false');
      } else if (!card.hidden) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var closeButton = event.target.closest('[data-stand-reminder-close]');

      if (!closeButton) return;

      event.preventDefault();
      event.stopPropagation();

      dismissReminder();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var browseButton = event.target.closest('.stand-reminder-card__browse');

      if (!browseButton) return;

      sessionStorage.setItem('standReminderDismissed', 'true');
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton = getCheckoutButton(event.target);

      if (!checkoutButton) return;

      var required = checkoutButton.getAttribute('data-stand-reminder-required') === 'true';
      var accepted = checkoutButton.getAttribute('data-stand-reminder-accepted') === 'true';

      if (required && !accepted && !wasDismissed()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        showReminderIfNeeded();

        var card = document.querySelector('[data-stand-reminder-card]:not([hidden])');
        if (card) {
          card.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }

        return false;
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      dismissReminder();
    }
  });

  var observer = new MutationObserver(function () {
    showReminderIfNeeded();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  showReminderIfNeeded();
})();